module.exports = __webpack_public_path__ + "img/06-02_Managing Negotiations.a8a21174.svg";